import { useQuery as e } from "@maat/store-hooks";
import { listingsApi as t } from "@maat/api-main";
//#region src/listings/useWorkspaceHostBlocksQuery.ts
var n = (n) => e({
	queryKey: [
		"listings",
		"workspace-host-blocks",
		n.start_date,
		n.end_date
	],
	queryFn: () => t.getWorkspaceHostBlocks(n),
	enabled: !!n.start_date && !!n.end_date,
	staleTime: 300 * 1e3
});
//#endregion
export { n as useWorkspaceHostBlocksQuery };
